import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { param: String }

  change(event) {
    const url = new URL(window.location.href)
    const value = event.currentTarget.value

    if (value) {
      url.searchParams.set(this.paramValue, value)
    } else {
      url.searchParams.delete(this.paramValue)
    }

    window.location.href = url.toString()
  }
}
